import { MouseEventHandler } from 'react';
import { ReactComponent as RefreshIcon } from '../../../../../assets/icons/refresh.svg';
import { ReactComponent as ErrorIcon } from '../../../../../assets/icons/server-error.svg';
import { useLocale } from '../../../../../context/NbLocalizationContext';
import { NbButton } from '../../../../../shared/components/button/Button';
import classes from './OrderCurrencyExchangeErrorState.module.scss';

type OrderCurrencyExchangeErrorStateProps = {
  message: string;
  onRetry: MouseEventHandler<HTMLButtonElement>;
  readOnly: boolean;
};

export const OrderCurrencyExchangeErrorState = ({
  message,
  onRetry,
  readOnly,
}: OrderCurrencyExchangeErrorStateProps) => {
  const { translation } = useLocale();

  return (
    <div
      data-testid="order-currency-exchange-error-state"
      className={classes.container}
    >
      <ErrorIcon className={classes.icon} />
      <span className={classes.message}>{message}</span>
      <NbButton
        color="primary"
        onClick={onRetry}
        startIcon={<RefreshIcon className={classes.refreshIcon} />}
        disabled={readOnly}
      >
        {translation.general.refresh}
      </NbButton>
    </div>
  );
};
